import React, {Component, useEffect} from 'react'
import classes from './SearchPage.module.css'
import {MDBAlert, MDBCol, MDBContainer, MDBRow} from "mdbreact";
import {Trans} from "react-i18next";
import ContentLoader from "react-content-loader"
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import ResultItem from "../CategoryPage/ResultItem/ResultItem";
import algoliaImg from "../../Assets/search-by-algolia-light-background.svg"
import {Helmet} from "react-helmet";
import {returnTran} from "../../Utils/Trans";
import firebase from "firebase";
import {getAPIPath} from "../../Utils/HelpingFunction";
import {Capacitor} from "@capacitor/core";

class SearchPage extends Component {
    typingTimer = null;

    constructor(props) {
        super(props);
        this.state = {
            hasResult: false,
            searchQuery: '',
            searchResult: [],
            noParams: false
        }
    }

    componentDidMount() {
        let searchStr = new URLSearchParams(this.props.location.search)


        if (searchStr.has("objectID")) {
                this.onSearchStart(searchStr.get("objectID"))
            } else {
                this.setState({
                    noParams: true
                })
            }
    }

    componentWillUnmount() {
        clearTimeout(this.typingTimer);
    }

    onSearchStart = (searchQuery) => {
        firebase.analytics().logEvent('start_search', {
            searchQuery: searchQuery,
        });
        this.setState({
            hasResult: false,
            searchQuery: searchQuery,
            noParams: false
        }, () => {
            return new Promise(async (resolve, reject) => {
                await fetch(getAPIPath("/api/search/all"), {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        uid: this.props.auth.uid,
                        searchStr: searchQuery
                    })
                })
                    .then((res) => res.json()).then((response) => {
                        this.setState({
                            searchResult: response.data
                        }, () => {
                            this.setState({
                                hasResult: true
                            })
                        })
                    })
            })
        })
    }

    onInput = (e) => {
        this.setState({searchQuery: e.target.value})
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
            if (this.state.searchQuery.length !== 0) {
                this.onSearchStart(this.state.searchQuery)
            }
        }, 750);

    }

    render() {

        return (
            <MDBContainer>
                <Helmet>
                    <title> { returnTran("SearchPage", "search-page") + ' | MeWeSearcher | ' + returnTran("LeftNavBar", "description")}</title>
                    {/*<meta property="fb:app_id" content="1293953327456577" />*/}
                    <meta property="og:type" content="website" />
                    <meta property="site_name" content="MeWeSearcher" />
                    <meta property="title" content={ returnTran("SearchPage", "search-page") + 'MeWeSearcher | ' + returnTran("LeftNavBar", "description")}/>
                    <meta name="description" content={ returnTran("SearchPage", "enter-to-search") + returnTran("LeftNavBar", "description")}/>
                    <meta name="keywords" content={"mewe, search mewe, 找尋mewe群組, 香港mewe"}/>
                    <meta property="og:title"
                          content={'MeWeSearcher | ' + returnTran("LeftNavBar", "description")}/>
                    <meta property="og:description" content={ returnTran("SearchPage", "enter-to-search") + returnTran("LeftNavBar", "description")}/>
                    <meta property="og:url" content={"https://mewesearcher.com" + window.location.pathname}/>
                    <meta property="og:site_name"
                          content={"MeWeSearcher"}/>
                    {/*<meta property="og:updated_time"*/}
                    {/*      content={new Date(this.state.article.lastModified.hasOwnProperty('seconds') ? this.state.article.lastModified.seconds * 1000 : this.state.article.lastModified._seconds * 1000 ).toISOString()}/>*/}
                    <meta httpEquiv="content-language"
                          content={localStorage.getItem("i18n-lang") === "en" ? "en-us" : "zh-Hant"}/>
                    <meta property="og:type" content="article"/>
                    <meta property="og:image" content={"https://imgur.com/a/AMU0634"}/>
                    <meta property="og:image:width" content="1280"/>
                    <meta property="og:image:height" content="720"/>
                    {/*<link rel="amphtml" href={"https://clipversity.com/amp/article/" + this.state.article.key}/>*/}
                </Helmet>
                <MDBRow>
                    <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                        <MDBAlert color='light' className={classes.EnterToSearch}>
                            <div>
                                <Trans>SearchPage.enter-to-search</Trans>
                                <img src={algoliaImg} className={classes.AlgoliaSearch}
                                     alt={'search system by algolia'}/>
                            </div>
                        </MDBAlert>
                        <input type='text'
                               className={classes.SearchInput}
                               placeholder={'search...'}
                               onChange={(e) => this.onInput(e)}
                        />

                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                        {
                            this.state.hasResult ?

                                this.state.searchResult.length !== 0 ?
                                    this.state.searchResult.map((data, index) => {
                                        if(index%3 ===0 && index !== 0 && Capacitor.getPlatform() === "web") {
                                            return(
                                                <React.Fragment key={'adc' + index}>
                                                    <ResultItem
                                                        isAd={true}

                                                    />
                                                    <ResultItem
                                                        key={data.objectID}
                                                        data={data}
                                                    />
                                                </React.Fragment>
                                            )
                                        }
                                        else{
                                            return (
                                                <ResultItem
                                                    key={data.objectID}
                                                    data={data}
                                                />
                                            )
                                        }

                                    })
                                    : <MDBAlert color='light' className={classes.NoMoreElement}>
                                        <Trans>PageSearch.no-tag</Trans>
                                    </MDBAlert>

                                :
                                this.state.searchQuery !== "" ?
                                    <div className={classes.SearchContentLoader}>
                                        <ContentLoader
                                            speed={2}
                                            width={"100%"}
                                            height={700}
                                            backgroundColor="#FFFFFF"
                                            foregroundColor="#FAFAFA"
                                        >
                                            <rect x="5" y="5" rx="10" ry="10" width="350" height="220"/>
                                            <rect x="425" y="5" rx="10" ry="10" width="350" height="220"/>
                                            <rect x="5" y="240" rx="10" ry="10" width="350" height="220"/>
                                        </ContentLoader>
                                    </div>
                                    : ""
                        }
                    </MDBCol>
                </MDBRow>


            </MDBContainer>
        )
    }

}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(SearchPage))